module.exports = __webpack_public_path__ + "static/media/ferrari.46164c33.png";